module.exports = __webpack_public_path__ + "img/logo6.b6e115ae.png";